(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ── Scroll state ── */
  var nav = document.getElementById('viynNav');
  var spacer = document.getElementById('viynNavSpacer');

  function setScrolled() {
    if (window.scrollY > 60) {
      nav.classList.add('is-scrolled');
    } else {
      nav.classList.remove('is-scrolled');
    }
  }

  // Update spacer height to match nav height (for non-transparent mode)
  function updateSpacer() {
    if (spacer) {
      spacer.style.height = nav.offsetHeight + 'px';
      document.documentElement.style.setProperty('--viyn-nav-h', nav.offsetHeight + 'px');
    }
  }

  window.addEventListener('scroll', setScrolled, { passive: true });
  window.addEventListener('resize', updateSpacer, { passive: true });
  setScrolled();
  updateSpacer();

  /* ── Predictive search ── */
  var searchInput   = document.getElementById('viynSearchInput');
  var searchResults = document.getElementById('viynSearchResults');
  var searchTimer;

  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = this.value.trim();
      if (q.length < 2) {
        searchResults.hidden = true;
        return;
      }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) { searchResults.hidden = true; return; }
            searchResults.innerHTML = products.map(function (p) {
              return '<a class="viyn-search-result-item" href="' + p.url + '">' +
                (p.featured_image
                  ? '<img src="' + p.featured_image + '" alt="' + p.title + '" loading="lazy">'
                  : '') +
                '<div>' +
                  '<div class="viyn-search-result-title">' + p.title + '</div>' +
                  '<div class="viyn-search-result-price">' + (p.price ? Shopify.formatMoney(p.price) : '') + '</div>' +
                '</div>' +
              '</a>';
            }).join('');
            searchResults.hidden = false;
          })
          .catch(function () { searchResults.hidden = true; });
      }, 280);
    });

    document.addEventListener('click', function (e) {
      if (!searchResults.contains(e.target) && e.target !== searchInput) {
        searchResults.hidden = true;
      }
    });

    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { searchResults.hidden = true; searchInput.blur(); }
    });
  }

  /* ── Mobile drawer ── */
  var hamburger = document.getElementById('viynHamburger');
  var drawer    = document.getElementById('viynMobileDrawer');
  var backdrop  = document.getElementById('viynDrawerBackdrop');
  var closeBtn  = document.getElementById('viynDrawerClose');

  function openDrawer() {
    drawer.hidden = false;
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    closeBtn && closeBtn.focus();
  }
  function closeDrawer() {
    drawer.hidden = true;
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    hamburger.focus();
  }

  hamburger && hamburger.addEventListener('click', openDrawer);
  closeBtn  && closeBtn.addEventListener('click', closeDrawer);
  backdrop  && backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
  });

  /* ── Drawer accordion ── */
  document.querySelectorAll('.viyn-drawer__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var children = this.nextElementSibling;
      this.setAttribute('aria-expanded', String(!expanded));
      if (children) children.hidden = expanded;
    });
  });

  /* ── Live cart count update ── */
  // Listen for cart:change events from Shopify theme (works with most themes)
  document.addEventListener('cart:change', function (e) {
    var count = e.detail && e.detail.cart && e.detail.cart.item_count;
    updateCartCount(count);
  });
  // Also poll on page show (covers back-button navigation)
  window.addEventListener('pageshow', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCartCount(c.item_count); })
      .catch(function () {});
  });

  function updateCartCount(count) {
    var badge = document.getElementById('viynCartCount');
    if (!badge) return;
    badge.textContent = count;
    if (count > 0) {
      badge.classList.remove('viyn-nav__cart-count--hidden');
    } else {
      badge.classList.add('viyn-nav__cart-count--hidden');
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viyn-bestsellers"] && !Shopify.designMode) return;
  try {
    
(function() {
  var tabs = document.querySelectorAll('.viyn-bs-tab');
  var cards = document.querySelectorAll('.viyn-bs-card');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var filter = this.dataset.filter;
      tabs.forEach(function(t) { t.classList.remove('on'); });
      this.classList.add('on');

      cards.forEach(function(card) {
        if (filter === 'all') {
          card.removeAttribute('hidden');
        } else {
          var tags = card.dataset.tags || '';
          if (tags.indexOf(filter) > -1) {
            card.removeAttribute('hidden');
          } else {
            card.setAttribute('hidden', '');
          }
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viyn-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  var hero = document.getElementById('viynSlides');
  if (!hero) return;
  var slides = hero.querySelectorAll('.viyn-hero__slide');
  var dots = document.querySelectorAll('.viyn-hero__dot');
  var counter = document.getElementById('viynCounter');
  var tag = document.getElementById('viynSlideTag');
  var tags = [];
  document.querySelectorAll('.viyn-hero__slide').forEach(function(s) {
    tags.push(s.dataset.tag || '');
  });
  var curr = 0, total = slides.length, timer;

  function goTo(n) {
    slides[curr].classList.remove('active');
    dots[curr].classList.remove('on');
    curr = (n + total) % total;
    slides[curr].classList.add('active');
    dots[curr].classList.add('on');
    if (counter) counter.textContent = String(curr + 1).padStart(2,'0') + ' / 0' + total;
  }

  function startTimer() {
    timer = setInterval(function() { goTo(curr + 1); }, 5200);
  }

  dots.forEach(function(d) {
    d.addEventListener('click', function() {
      clearInterval(timer);
      goTo(parseInt(this.dataset.i));
      startTimer();
    });
  });

  startTimer();
})();

  } catch(e) { console.error(e); }
})();
})();
